import { createSelector } from '@ngrx/store';

const selectAuth = (state: any) => state.auth;

export const selectToken = createSelector(
  selectAuth,
  (state) => state.token
);

export const selectError = createSelector(
  selectAuth,
  (state) => state.error
);

export const selectIsLoading = createSelector(
  selectAuth,
  (state) => state.isLoading
);

export const selectIsLoggedIn = createSelector(
  selectAuth,
  (state) => state.isLoggedIn
);

export const selectAuthUser = createSelector(
  selectAuth,
  (state) => state.user
);

export const selectAuthState = createSelector(
    selectAuth,
    (state) => state
);


export const selectLoginSuccess = createSelector(
  selectAuth,
  (state) => ({ isLoggedIn: state.isLoggedIn, user: state.user })
);

export const selectLoginFailure = createSelector(
  selectAuth,
  (state) => state.error
);

export const selectUpdateUserSuccess = createSelector(
  selectAuth,
  (state) => ({ user: state.user })
);

export const selectUpdateUserFailure = createSelector(
  selectAuth,
  (state) => state.error
);

export const selectRegisterSuccess = createSelector(
  selectAuth,
  (state) => state.user
);

export const selectRegisterFailure = createSelector(
  selectAuth,
  (state) => state.error
);

export const selectLogoutSuccess = createSelector(
  selectAuth,
  (state) => state.logoutSuccess
);

// Selector for logout failure
export const selectLogoutFailure = createSelector(
  selectAuth,
  (state) => state.logoutFailure
);
